import React from 'react';
import { Placeholder } from '../Placeholder';
import { FadeUp } from '../FadeUp';
import { Heading2 } from '../Heading2';
import { bonuses } from '../../data/bonuses';
export function Bonuses() {
  return <section className="px-5 pb-14 pt-6 md:pb-20 md:pt-8" data-id="element-75" data-mp="1ckejeyalzf7o">
      <FadeUp className="mx-auto w-full max-w-[620px]" data-id="element-76" data-mp="1citlqzszzg5l">
        <p className="text-center text-[12px] font-extrabold uppercase tracking-[0.18em] text-brand" data-id="element-77" data-mp="18kvw5vvbes1o">
          And there's more
        </p>

        <Heading2 className="mt-3" data-id="element-78" data-mp="257hcvc0fgzr2">
          But wait… <span className="text-gain" data-id="element-79" data-mp="20btq139f4ioq">that's not all</span>
        </Heading2>

        <p className="mx-auto mt-4 max-w-[480px] text-center text-[16px] text-ink/70" data-id="element-80" data-mp="1w8nk5wq7wtis">
          If you made it this far, we've got more gifts for you and your kid
        </p>
      </FadeUp>

      <div className="pt-12" data-id="element-81" data-mp="ktqk7rshwjwn">
        <FadeUp className="mx-auto w-full max-w-[620px]" data-id="element-82" data-mp="kv1ixd7331gw">
          <ul className="grid grid-cols-2 gap-4" data-id="element-83" data-mp="fux4dspqkgtb">
            {bonuses.map((bonus, index) => <li key={bonus.title} className="text-center" data-id="element-84" data-mp="1etn9o3q7l3ko" data-mpi={index}>
                {bonus.image ? <img src={bonus.image} alt={`${bonus.title} cover`} width={1024} height={1536} loading="lazy" decoding="async" className="mx-auto block w-full" style={{
              aspectRatio: '2 / 3',
              objectFit: 'contain'
            }} data-id="element-85" data-mp="1jsrigt980zah" /> : <Placeholder label={`BONUS ${index + 1} COVER`} ratio="2 / 3" className="w-full" data-id="element-86" data-mp="10ufb9d1vdzhj" />}
                <p className="mt-3 text-[12px] font-extrabold uppercase tracking-wide text-brand" data-id="element-87" data-mp="n3ik7qnldqcl">
                  Bonus {index + 1} 🎁
                </p>
                <h3 className="mt-1 text-[14px] font-extrabold" data-id="element-88" data-mp="d4b5p054fpnw">{bonus.title}</h3>
                <p className="mt-1 text-[12px] text-ink/65" data-id="element-89" data-mp="d6e5gbw2sx5t">{bonus.description}</p>
                <p className="mt-1 text-[12px] text-pain line-through" data-id="element-90" data-mp="i2uqgx7zaveo">{bonus.value}</p>
              </li>)}
          </ul>

          <p className="mt-10 text-center text-[20px] font-extrabold" data-id="element-91" data-mp="2f1v7fbtfl0nh">
            Total bonus value: <span className="line-through" data-id="element-92" data-mp="2f00htk77skd2">$184</span> →{' '}
            <span className="text-gain" data-id="element-93" data-mp="2b11eu551mxo9">FREE</span>
          </p>
        </FadeUp>
      </div>
    </section>;
}